import PropTypes from 'prop-types';
import Link from 'next/link';
import addTabnabbing from '../../utils/addTabnabbing';

import CorusImage from '../CorusImage/CorusImage';

export default function SingleChannel({ channel }) {
	const channelLink = (channel.channelFinder.channelTitleLink) ? channel.channelFinder.channelTitleLink.url : null;

	return (
		<div className="where-to-watch__channel_single">

			<div className="channel-logo">
				{
					(channel.featuredImage) ? (

						<a
							href={channelLink}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={`Link to ${channel.featuredImage.node.altText}`}
						>
							<CorusImage
								alt={channel.featuredImage.node.altText}
								className="wtw-channel-logo"
								src={channel.featuredImage.node.sourceUrl}
								title={channel.featuredImage.node.altText}
								width={200}
							/>
						</a>

					) : null
				}
			</div>

			<div className="channel-info">

				<div className="channel-title"><a href={channelLink} target="_blank" rel="noopener noreferrer">{channel.title}</a></div>
				{
					(channel.channelFinder.description) ? (

						<div className="channel-desc">
							{addTabnabbing(channel.channelFinder.description)}
						</div>

					) : null
				}

				{
					(channel.channelFinder.channelNumberInformation) ? (

						<div className="channel-listings">
							{
								(channel.channelFinder.channelNumberInformation.map(
									(item, index) => (
										<p key={index.toString()}>
											{item.channelInformation}
										</p>
									),
								))
							}
						</div>

					) : null
				}

				{
					channel.channelFinder.watchNowBtnLink && channel.channelFinder.watchNowBtnText ? (
						<div className="channel-watch-now-button-container">
							<Link
								href={channel.channelFinder.watchNowBtnLink}
								aria-label={`Link to the page ${channel.channelFinder.watchNowBtnLink}`}
								rel="noopener"
								className="channel-watch-now-button"
								target="_blank"
							>
								{channel.channelFinder.watchNowBtnText}
							</Link>
						</div>
					) : null
				}
			</div>

		</div>
	);
}

SingleChannel.propTypes = {
	channel: PropTypes.object.isRequired,
};
